/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import _ from 'lodash';
export * from './notification-defaults';
export * from './notifications';
export function getBidRequestState(br, scenarios, projects) {
    const brScenarios = (scenarios?.map((s) => ({ ...s, id: 'id' in s ? s.id : -1 })) ??
        br.scenarios);
    const brProjects = _.uniqBy(projects ?? brScenarios.map((s) => s.project).filter((p) => p), (p) => p.project_id);
    const getProjectIds = () => _.uniq(brScenarios.map((s) => s.bid_matrix_scenario.project_id));
    const getNumOfProjects = () => getProjectIds().length;
    const checkDevInputsComplete = () => {
        const projectData = brProjects.map((p) => _.pick(p, 'land', 'dev', 'txm'));
        return projectData.length === getNumOfProjects() && projectData.every((x) => x);
    };
    const getAllApprovals = () => [
        br.dev_approval,
        br.txm_approval,
        br.procurement_approval,
        br.eng_approval,
        br.finance_approval,
    ];
    const getBidMatrix = () => brScenarios.map((s) => ({
        ...s.bid_matrix_scenario,
        uuid: s.uuid,
        version: s.version,
        id: 'id' in s ? s.id : undefined,
    }));
    const getProjectById = (id) => {
        if (id === undefined || id === null)
            return null;
        return (brProjects?.find((p) => {
            if (typeof id === 'number') {
                if ('id' in p) {
                    return p.id === id;
                }
                throw new Error('Bid request state must be initialized with project records to get by ID');
            }
            return p.project_id === id;
        }) ?? null);
    };
    const getEngInputsIds = () => (brScenarios.map((s) => s.pa_scenario_id).filter(Boolean) ?? []);
    const getScenariosWithPricing = () => brScenarios?.filter((s) => s.pricing_scenario_id) ?? [];
    return {
        ...br,
        scenarios: brScenarios,
        projects: brProjects,
        getProjectIds,
        getNumOfProjects,
        checkDevInputsComplete,
        getAllApprovals,
        getBidMatrix,
        getProjectById,
        getEngInputsIds,
        getScenariosWithPricing,
        isCompleted: br.completed || br.aborted,
    };
}
//# sourceMappingURL=index.js.map